import { RootState } from '../types/store.type';

export const bundleDetailsSelector = (state: RootState) =>
  state.orders.orderDetails.bundle;

export const orderDetailsSelector = (state: RootState) =>
  state.orders.orderDetails.orders;

export const plansSelector = (state: RootState) =>
  state.orders.orderDetails.plans;

export const queryTextSelector = (state: RootState) => state.orders.queryText;

export const customerDetailsSelector = (state: RootState) =>
  state.orders.orderDetails.bundle.customer;

export const domainBundlesSelector = (state: RootState) => {
  return state.orders.domainBundles;
};
